var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"special-header font_size_1000rem py-2"},[_vm._v("\n  "+_vm._s(_vm.currentSectionTitle)+"\n")]),(!!_vm.question.is_proxy_enabled)?_c('span',{staticClass:"proxy"},[_vm._v("Proxy Question")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }